import React, { useState } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiStar, FiChevronLeft, FiChevronRight, FiUser } = FiIcons;

const Testimonials = () => {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);

  const testimonials = [
    {
      name: 'Danny Dickinson',
      review: 'Called Rapid Drainage Solutions for an issue with smelly drains. Spoke to Rick who came out the same day and performed a CCTV inspection. Rick showed me the problem and explained what could be done. Upon further inspection of another man hole, a blockage was identified and cleared by Rick. Very pleasant and straightforward. Would recommend.',
      rating: 5,
      service: 'CCTV Inspection & Drain Clearing'
    },
    {
      name: 'Ian Mcilwee',
      review: 'A huge thank you to Rick and Reece from Rapid Drainage Solutions who completed a drain inspection very late in the afternoon and returned the next day to fix the issue with the drains. The problem was clearly explained to me and how it was going to be resolved. Rick and Reece are very polite and professional and I can highly recommend RDS.',
      rating: 5,
      service: 'Drain Inspection & Repair'
    },
    {
      name: 'Kai Hong Li',
      review: 'Sewage backflew suddenly from the manhole early in the morning. RDS gave me a phone call just five minutes to ask the details of the issue after I had put on a request online. As promised they arrived within 2 hours. Then they found out where was blocked and cleared my drainage in just 30 minutes. They are true professional plumber and just charge me a very low fee, which is much lower than the last time by another plumber.',
      rating: 5,
      service: 'Emergency Drain Unblocking'
    },
    {
      name: 'Jean Gillies',
      review: 'Cannot thank this company enough. They came out at short notice for our community centre and sorted one drain then came back to deal with a collapsed drain. Really pleased with the work and extremely professional. Cleaned up afterwards. Great to see people take pride in their work. Thank You.',
      rating: 5,
      service: 'Commercial Drain Repair'
    },
    {
      name: 'Nicola Fitzpatrick',
      review: 'What can I say other than a massive thank you to this company! They were able to sort out my blocked drain problem immediately and were super professional & friendly. This company comes highly recommended and just to note, they did not charge an excessive fee which was very much appreciated. Thanks again Rick & son for a wonderful service.',
      rating: 5,
      service: 'Drain Unblocking'
    },
    {
      name: 'Angelina',
      review: 'Very pleased with the service I received from the company, they arrived when they said they would. Excellent service, engineers very polite, professional service with perfect result. I can\'t recommend them highly enough. I would definitely would use again.',
      rating: 5,
      service: 'Professional Drainage Service'
    },
    {
      name: 'James O\'Donnell',
      review: 'Very good service, Phoned and came same day, They found the blockage very quickly and explained what the problem was, didn\'t get the 2 guys name but they were very good, Highly recommend',
      rating: 5,
      service: 'Same Day Drain Service'
    },
    {
      name: 'Uday Ukc',
      review: 'Good communication and as they promised they are on time. Mainly they done their work in affordable prices that\'s very much appreciated 👍',
      rating: 5,
      service: 'Drainage Services'
    }
  ];

  const nextTestimonial = () => {
    setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentTestimonial((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section id="testimonials" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            What Our Customers Say
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Don't just take our word for it. Here's what our customers say about 
            our professional drainage services and customer care.
          </p>
        </motion.div>

        {/* Main Testimonial */}
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="relative bg-blue-50 rounded-2xl p-8 lg:p-12 mb-12"
        >
          <div className="text-center">
            {/* Stars */}
            <div className="flex justify-center mb-6">
              {[...Array(testimonials[currentTestimonial].rating)].map((_, i) => (
                <SafeIcon key={i} icon={FiStar} className="text-yellow-400 text-2xl fill-current" />
              ))}
            </div>

            {/* Review Text */}
            <blockquote className="text-lg lg:text-xl text-gray-700 mb-8 italic max-w-4xl mx-auto">
              "{testimonials[currentTestimonial].review}"
            </blockquote>

            {/* Customer Info */}
            <div className="flex items-center justify-center space-x-4">
              <div className="bg-blue-200 p-3 rounded-full">
                <SafeIcon icon={FiUser} className="text-blue-600 text-xl" />
              </div>
              <div className="text-left">
                <div className="font-semibold text-gray-900">{testimonials[currentTestimonial].name}</div>
                <div className="text-gray-600">{testimonials[currentTestimonial].service}</div>
              </div>
            </div>
          </div>

          {/* Navigation */}
          <button
            onClick={prevTestimonial}
            className="absolute left-4 top-1/2 -translate-y-1/2 bg-white p-3 rounded-full shadow-lg hover:shadow-xl transition-shadow"
          >
            <SafeIcon icon={FiChevronLeft} className="text-gray-600" />
          </button>
          <button
            onClick={nextTestimonial}
            className="absolute right-4 top-1/2 -translate-y-1/2 bg-white p-3 rounded-full shadow-lg hover:shadow-xl transition-shadow"
          >
            <SafeIcon icon={FiChevronRight} className="text-gray-600" />
          </button>
        </motion.div>

        {/* Testimonial Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.slice(0, 6).map((testimonial, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: index * 0.1 }}
              className="bg-white border border-gray-200 rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow"
            >
              <div className="flex mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <SafeIcon key={i} icon={FiStar} className="text-yellow-400 fill-current" />
                ))}
              </div>
              <p className="text-gray-700 mb-4 line-clamp-4">
                "{testimonial.review.length > 120 ? testimonial.review.substring(0, 120) + '...' : testimonial.review}"
              </p>
              <div className="flex items-center space-x-3">
                <div className="bg-gray-100 p-2 rounded-full">
                  <SafeIcon icon={FiUser} className="text-gray-600" />
                </div>
                <div>
                  <div className="font-semibold text-gray-900 text-sm">{testimonial.name}</div>
                  <div className="text-gray-600 text-xs">{testimonial.service}</div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Trust Stats */}
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="mt-16 grid md:grid-cols-4 gap-8 text-center"
        >
          <div>
            <div className="text-3xl font-bold text-blue-600">500+</div>
            <div className="text-gray-600">Happy Customers</div>
          </div>
          <div>
            <div className="text-3xl font-bold text-blue-600">5 Star</div>
            <div className="text-gray-600">Average Rating</div>
          </div>
          <div>
            <div className="text-3xl font-bold text-blue-600">15+</div>
            <div className="text-gray-600">Years Experience</div>
          </div>
          <div>
            <div className="text-3xl font-bold text-blue-600">24/7</div>
            <div className="text-gray-600">Emergency Service</div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Testimonials;